import ErplyAPI from 'service/ErplyAPI';
/**
 *
 * @param {Object} params Query parameters to send with the request.
 * @returns {arrayOf(Object)} Records returned by Erply API that match the params, if no params specified, all warehouses will be returned.
 */
export const getWarehouses = (params) =>
  ErplyAPI.request('getWarehouses', params);
export const saveWarehouse = (params) =>
  ErplyAPI.request('saveWarehouse', params);
